export default "__VITE_ASSET__BFEAFto___"